import { withRestoreParam } from "@impero-com/ui/domain";

import { WebRoute } from "routes";

// Marks an arrival through the old Your pending tests route, the only time the page explains where tests went
export const FROM_DEPRECATED_PENDING_TESTS_PAGE_PARAM = "fromPendingTests";

export const dashboardPendingActivitiesUrl = withRestoreParam(
    WebRoute.DASHBOARD_PENDING_ACTIVITIES
);

export const dashboardPendingActivitiesFromDeprecatedPendingTestsPageUrl = `${dashboardPendingActivitiesUrl}&${FROM_DEPRECATED_PENDING_TESTS_PAGE_PARAM}`;
